import { useQuery } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { triggersV2QueryKeys } from "./triggersV2QueryKeys";

/**
 * A realistic, dereferenced sample of every platform event type: the envelope,
 * every namespace root with a full record under it, and the ``root.path`` names
 * a condition or ``{{ }}`` template may use.
 *
 * The server builds it from a fixed scenario through the evaluator's own
 * namespace, so it changes only with a deploy; it is fetched once per session
 * and never considered stale.
 */
export function useEventSamples(orgId?: string) {
  const { triggerV2Service } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);

  return useQuery({
    queryKey: triggersV2QueryKeys.eventSamples(resolvedOrgId),
    queryFn: ({ signal }) =>
      triggerV2Service.getEventSamples({ abortSignal: signal }),
    staleTime: Infinity,
  });
}
